export default [
  { text: "tipojuntadirectiva.ORDINARIA", value: "ORDINARIA" },
  { text: "tipojuntadirectiva.EXTRAORDINARIA", value: "EXTRAORDINARIA" },
];
